import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './poyais-ui/global.css';
import App from './App';
import { LangProvider } from './i18n';
import { ThemeProvider } from './theme-context';
import { startPageViews } from './analytics';

// Müşteri raporu (/r/:slug) panelden bağımsız, panel oturumu gerektirmeyen ayrı bir sayfa.
const ReportApp = React.lazy(() => import('./report/ReportApp'));

startPageViews();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  window.location.pathname.startsWith('/r/') ? (
    <Suspense fallback={null}>
      <ReportApp />
    </Suspense>
  ) : (
    <BrowserRouter>
      <ThemeProvider>
        <LangProvider>
          <App />
        </LangProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
);
